// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"wrapper___VZfJx"};